module.exports = __webpack_public_path__ + "static/media/inetcfg_2301.c775dd1b.ico";